<template>
  <div class="">
    <router-view></router-view>
    <ModalFeedback v-if="isLogged" />
  </div>
</template>

<script>
import ModalFeedback from "./components/Feedback/ModalFeedback";
export default {
  components: {ModalFeedback},
  created() {
    this.$store.dispatch('FETCH_USER')
  },
  computed :{
    isLogged() {
      return this.$store.state.logged;
    }
  }

}
</script>
